export const TOGGLE_DEVICE = "TOGGLE_DEVICE";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

export const EXPAND_MENU = "EXPAND_MENU";

export const SWITCH_EFFECT = "SWITCH_EFFECT";

export const PUBLIC_LAYOUT = "PUBLIC_LAYOUT";

export const PERMISSION = "PERMISSION";

export const PROFILE = "PROFILE";

export const TAG = "TAG";

export const REPORT = "REPORT";

export const NOTI_REPORT = "NOTI_REPORT";

export const LOADING_REPORT = "LOADING_REPORT";

export const TIMEZONE = "TIMEZONE";

export const CURRENCY = "CURRENCY";

export const RESET_MENU = "RESET_MENU";

export const SETTING = "SETTING";
